import { render, staticRenderFns } from "./AssessmentText.vue?vue&type=template&id=da67c386"
import script from "./AssessmentText.vue?vue&type=script&lang=js"
export * from "./AssessmentText.vue?vue&type=script&lang=js"
import style0 from "./AssessmentText.vue?vue&type=style&index=0&id=da67c386&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports